export const campaignFilterStatus = ["active", "paused", "inactive"] as const;
